/**
 * BentoBox composite — public API.
 * Re-export the component and its props types for consumers.
 */
export {
  BentoBox,
  BentoBoxCell,
  type BentoBoxProps,
  type BentoBoxCellProps,
} from './BentoBox';
